import ApplyRounding from '../../../../../../../utils/math/ApplyRounding';

export function candleTriggerDetailParser(_root, softOrder) {
  const tradePlanId = softOrder.tradePlanId;
  const tacticValue = softOrder.value.tacticValue;
  const candleDuration = tacticValue.candleDuration;
  const timeUnit = tacticValue.timeUnit;
  const breakBy = tacticValue.breakBy;
  const priceToBreak = tacticValue.priceToBreak || null;
  const priceToBreakHigh = tacticValue['priceToBreak (long)'] || null;
  const priceToBreakLow = tacticValue['priceToBreak (short)'] || null;
  let breakPrice = null;
  if (priceToBreak) breakPrice = '$' + ApplyRounding(priceToBreak, 2);
  if (priceToBreakHigh) {
    breakPrice = `$${ApplyRounding(priceToBreakLow, 2)}/$${ApplyRounding(
      priceToBreakHigh,
      2
    )}`;
  }
  return {
    details: {
      candleDuration,
      timeUnit,
      breakBy,
      breakPrice,
      tradePlanId,
    },
    triggerPrice: {
      priceToBreak,
      priceToBreakHigh,
      priceToBreakLow,
    },
  };
}
// {
//   "messageType": "softOrder",
//   "tradePlanId": 1643929558922,
//   "tradePlanType": "ALERT",
//   "value": {
//       "timeStamp": "1643929558989",
//       "tacticId": "CANDLE_TRIGGER|ALERT16439168413791",
//       "tactic": "CANDLE_TRIGGER",
//       "symbol": "TSLA",
//       "tacticValue": {
//           "priceToBreak (long)": 101,
//           "priceToBreak (short)": 99,
//           "candleDuration": 1,
//           "breakBy": 0,
//           "isBreakLongTrigger": true,
//           "isBreakShortTrigger": true,
//           "timeUnit": "DAYS",
//           "score": 0
//       }
//   }
// }
